import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { formatDateTimeOrDash } from '#/utils/date';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

const StocktakeMainInfoCard = ({ detail, actions = null }) => {
  const stocktakeNo = displayOrDash(detail?.stocktakeNo);
  const lineCount = detail?.lineCount ?? detail?.lines?.length ?? 0;
  const remark = displayOrDash(detail?.remark);
  const createdAt = formatDateTimeOrDash(
    detail?.record?.createdAt ?? detail?.createdAt,
  );
  const updatedAt = formatDateTimeOrDash(
    detail?.record?.updatedAt ?? detail?.updatedAt,
  );

  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-panel p-4 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <h2 className="text-2xl font-bold text-gray-900">{stocktakeNo}</h2>
          <p className="text-sm text-gray-600">
            項目數
            {' '}
            {lineCount}
          </p>
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            {actions}
          </div>
        ) : null}
      </div>

      <div
        className={cn(
          'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
          'sm:grid-cols-2 md:grid-cols-4',
        )}
      >
        <div>
          <p className="text-xs text-gray-500">建立</p>
          <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">{createdAt}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">修改</p>
          <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">{updatedAt}</p>
        </div>
        <div className="sm:col-span-2 md:col-span-2">
          <p className="text-xs text-gray-500">備註</p>
          <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">
            {remark}
          </p>
        </div>
      </div>
    </div>
  );
};

StocktakeMainInfoCard.propTypes = {
  detail: PropTypes.object.isRequired,
  actions: PropTypes.node,
};

export default StocktakeMainInfoCard;
